import { useUnit } from 'effector-react'
import { useStyles } from './styles'
import { PurchaseOption } from '@/entities/cases'
import { lang } from '@/shared/constants/lang'
import { $userLanguage } from '@/entities/user'
import { Icon, TIconVariant } from '@/shared/ui/icon'
import { AppButton } from '@/shared/ui/button'
interface PurchaseOptionButtonProps extends PurchaseOption {
  onClick: () => void
  amount: number
}

export const PurchaseOptionButton = (props: PurchaseOptionButtonProps) => {
  const { onClick, available, price, amount, currency } = props
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)

  const icon: TIconVariant = currency === 'keys' ? 'gamedKey' : 'gamed'
  return (
    <AppButton onClick={onClick} fullWidth className={classes.root} data-isenoughkeys={available}>
      <div className={classes.divWrapper}>
        <span className={classes.span}>{lang[userLang].pages.btnTexts.openBox}</span>
      </div>
      <div className={classes.divWrapper}>
        <Icon view={icon} width={34} />
        <span className={classes.span}>
          {amount} / {price}
        </span>
        <span className={classes.span}>{lang[userLang].pages.btnTexts.key}</span>
      </div>
    </AppButton>
  )
}
